import { Injectable } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';

@Injectable()
export class SharesService extends AnalyticsService {
  protected apiPath = '/shares/';
}
